module.exports = __webpack_public_path__ + "img/source_sw-con03.af253886.png";